import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "room col-sm-6 col-md-4 mw room--category-normal" }
const _hoisted_2 = { class: "room__inner" }
const _hoisted_3 = { class: "room__body" }
const _hoisted_4 = { class: "room__title" }
const _hoisted_5 = { class: "room__meta" }
const _hoisted_6 = { class: "room__meta-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_8 = { class: "room__meta-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-clock" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "room__meta-item text-red"
}
const _hoisted_11 = { class: "room__img" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h2", _hoisted_4, [
          _createVNode("a", {
            href: '/' + _ctx.location + '/rooms/' + _ctx.room.url,
            innerHTML: _ctx.room.name
          }, null, 8, ["href", "innerHTML"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" 3-" + _toDisplayString(_ctx.room.maxPlayers), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.room.time), 1)
          ]),
          (_ctx.room.headToHead)
            ? (_openBlock(), _createBlock("div", _hoisted_10, " HEAD-TO-HEAD AVAILABLE "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("figure", _hoisted_11, [
        _createVNode("a", {
          href: '/' + _ctx.location + '/rooms/' + _ctx.room.url
        }, [
          _createVNode("picture", null, [
            (_ctx.room.imageWebp)
              ? (_openBlock(), _createBlock("source", {
                  key: 0,
                  "data-srcset": _ctx.room.imageWebp.file.url,
                  alt: _ctx.room.name,
                  type: "image/webp"
                }, null, 8, ["data-srcset", "alt"]))
              : _createCommentVNode("", true),
            _createVNode("img", {
              class: "lazyload",
              "data-src": _ctx.room.image.file.url,
              alt: _ctx.room.name
            }, null, 8, ["data-src", "alt"])
          ])
        ], 8, ["href"])
      ])
    ])
  ]))
}